module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [(_vm.documentTypes) ? _c('div', {
    staticClass: "centered types-addition"
  }, [_c('draggable', {
    attrs: {
      "options": {
        disabled: _vm.editableDocumentType !== null
      }
    },
    model: {
      value: (_vm.documentTypesCopy),
      callback: function($$v) {
        _vm.documentTypesCopy = $$v
      },
      expression: "documentTypesCopy"
    }
  }, _vm._l((_vm.documentTypesCopy), function(item) {
    return _c('span', {
      staticClass: "document-wrapper",
      on: {
        "click": function($event) {
          return _vm.getDocumentType(item.id)
        }
      }
    }, [(_vm.editableDocumentType !== item.id) ? _c('router-link', {
      key: item.id,
      staticClass: "city-title",
      attrs: {
        "active-class": "is-active",
        "to": {
          name: 'Document',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n        ")]) : _c('span', {
      staticClass: "edit-document-wrapper"
    }, [_c('a', {
      staticClass: "delete hide-edit-document",
      on: {
        "click": function($event) {
          return _vm.toggleEditDocumentType(item.id)
        }
      }
    }), _vm._v(" "), _c('b-input', {
      staticClass: "edit-document-input",
      model: {
        value: (_vm.newDocumentTypeName),
        callback: function($$v) {
          _vm.newDocumentTypeName = $$v
        },
        expression: "newDocumentTypeName"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "apply-icon is-medium",
      attrs: {
        "src": "/static/img/icons/apply.svg"
      },
      on: {
        "click": _vm.handleUpdateDocumentTypes
      }
    })], 1), _vm._v(" "), _c('img', {
      staticClass: "edit-icon",
      attrs: {
        "src": "/static/img/icons/edit.svg"
      },
      on: {
        "click": function($event) {
          return _vm.toggleEditDocumentType(item.id)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.typeAdditionVisible) ? _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.toggleTypeAddition
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить новый тип\n    ")]) : _c('b-field', {
    staticClass: "city-addition-input"
  }, [_c('b-input', {
    model: {
      value: (_vm.typeName),
      callback: function($$v) {
        _vm.typeName = $$v
      },
      expression: "typeName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-primary button",
    on: {
      "click": _vm.handleAddType
    }
  }, [_vm._v("Добавить")]), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-warning button",
    on: {
      "click": _vm.toggleTypeAddition
    }
  }, [_vm._v("Отмена")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.documentType) ? _c('div', {
    staticClass: "documents-container"
  }, [_c('div', {
    staticClass: "documents"
  }, [_c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveDocuments()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), (_vm.documentsData && _vm.documentsData.length) ? _c('table', [_vm._m(0), _vm._v(" "), _c('draggable', {
    staticClass: "fake-table",
    model: {
      value: (_vm.documentsData),
      callback: function($$v) {
        _vm.documentsData = $$v
      },
      expression: "documentsData"
    }
  }, _vm._l((_vm.documentsData), function(document) {
    return _c('DocumentItem', {
      key: document.id,
      attrs: {
        "document": document
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": function($event) {
        return _vm.handleAddDocument(_vm.documentType.id)
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить документ\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column delete-document-type",
    on: {
      "click": function($event) {
        return _vm.deleteDocumentType(_vm.documentType.id)
      }
    }
  }, [_c('span', [_vm._v("Удалить")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("№ документа")]), _vm._v(" "), _c('td', [_vm._v("Название документа")]), _vm._v(" "), _c('td', [_vm._v("Период актуальности информации")]), _vm._v(" "), _c('td', [_vm._v("Дата раскрытия")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-201003a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/Documents.vue
// module id = 907
// module chunks = 0